import axios from 'axios';

export const fetchAutocompleteSuggestions = async (query, { signal } = {}) => {
  try {
    const response = await axios.post(
      '/autocomplete',
      {
        query,
      },
      { signal }
    );

    return Array.isArray(response.data?.completions)
      ? response.data.completions.filter(
          (suggestion) => typeof suggestion === 'string' && suggestion.trim()
        )
      : [];
  } catch (error) {
    if (axios.isCancel(error) || error?.name === 'CanceledError') {
      return [];
    }

    console.error('Error fetching suggestions:', error);
    return [];
  }
};

// Keep the old export until the report search component is migrated. Report
// suggestions are currently disabled, so this is compatibility-only.
export const geminiInput = fetchAutocompleteSuggestions;
